import React, { FC, memo } from 'react'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { useLimitedList } from '@ucheba/utils/hooks/useLimitedList'
import { IOlympiadsListProps } from '../types'
import { OlympiadsListItem } from './OlympiadsListItem'
import SC from '../base/OlympiadsList.styles'

const { Block } = SC

/** Список олимпиад */
const OlympiadsList: FC<IOlympiadsListProps> = (props) => {
  const { showMore = true, items, limit = 0, onShowAll } = props
  const { limitedItems, showAll, countShowed } = useLimitedList({
    showMore,
    items,
    limit,
    onShowAll,
  })

  return (
    <>
      <Block>
        {limitedItems.map((olympiad) => (
          <OlympiadsListItem {...olympiad} key={olympiad.id} />
        ))}
      </Block>

      {!!countShowed && items.length > 3 && (
        <>
          <Spacing spacing='xlarge' />

          <Button block color='blue' view='outline' onClick={showAll}>
            Показать все олимпиады
          </Button>
        </>
      )}
    </>
  )
}

export { OlympiadsList }
export default memo(OlympiadsList)
